import React, { useState } from 'react';
import axios from 'axios';
import { Container, Typography, TextField, Button, Table, TableContainer, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Modal, Spinner, Alert } from 'react-bootstrap';
import '../components/App.css';
import { ADMIN_BASE_URL } from '../config/config';

const AdminReferAndEarnById = () => {
  const [formData, setFormData] = useState({
    userID: '',
    amount: '',
    refid: '',
    currency: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const { userId } = useParams();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${ADMIN_BASE_URL}/earnings`, { ...formData, userID: userId });
      console.log(response.data);
      setSuccess(true);
      setFormData({
        userID: '',
        amount: '',
        refid: '',
        currency: ''
      });
    } catch (error) {
      console.error('Error submitting data:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  
  const handleCloseAlerts = () => {
    setSuccess(false);
    setError(false);
  };

  return (
    <Container>
        <Typography variant="h4" className="admin-message-title" gutterBottom>
          Earnings Table
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>User ID</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Ref ID</TableCell>
                <TableCell>Currency</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TextField name="userID" value={userId} disabled />
                </TableCell>
                <TableCell>
                  <TextField name="amount" value={formData.amount} onChange={handleChange} />
                </TableCell>
                <TableCell>
                  <TextField name="refid" value={formData.refid} onChange={handleChange} />
                </TableCell>
                <TableCell>
                  <TextField name="currency" value={formData.currency} onChange={handleChange} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
        </div>
        <Modal show={loading} onHide={handleCloseAlerts}>
          <Modal.Body className="text-center">
            <Spinner animation="border" />
            <p>Loading...</p>
          </Modal.Body>
        </Modal>
        <Modal show={success} onHide={handleCloseAlerts}>
          <Modal.Body className="text-center">
            <Alert variant="success" onClose={handleCloseAlerts} dismissible>
              Data submitted successfully!
            </Alert>
          </Modal.Body>
        </Modal>
        <Modal show={error} onHide={handleCloseAlerts}>
          <Modal.Body className="text-center">
            <Alert variant="danger" onClose={handleCloseAlerts} dismissible>
              Error submitting data. Please try again later.
            </Alert>
          </Modal.Body>
        </Modal>
    </Container>
  );
};

export default AdminReferAndEarnById;
